import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import api from "../../api/axios";
import { Loader2 } from 'lucide-react';

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        // Ping the server to check if the session is alive
        await api.get('/check-auth');
        setIsAuthenticated(true);
      } catch (err) {
        // Server said the token is invalid or expired
        localStorage.removeItem('admin_token');
        setIsAuthenticated(false);
      }
    };

    verifyToken();
  }, [token]);

  // While checking with the server, show a loader
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="animate-spin text-[#ffaa00]" size={40} />
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
};

export default ProtectedRoute;